import { action } from '@ember/object';
import type Owner from '@ember/owner';

import type { PopupData } from 'webapp-types';
import { PopupEvent } from 'webapp/enums/enums';

import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class MobilePopupAppSuggestionComponent extends PopupInnerModalComponent<PopupData.Mobile.AppSuggestion> {
	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.args.model.on(PopupEvent.CLOSING, this, () => {
			this.hideAfterFirstInteraction();
			this.popupData.onWebAppContinue();
		});
	}

	hideAfterFirstInteraction(): void {
		// Safari in Private Browsing Mode supports localStorage but all calls to setItem throw QuotaExceededError
		try {
			localStorage.setItem('skipDesignerMobileAppSuggestion', '1');
		} catch (_e) {
			// just ignore, not important enough to warn user
		}
	}

	@action
	openMobileApp(): void {
		this.hideAfterFirstInteraction();
		this.popupData.onMobileAppContinue();
	}
	<template>
		<div class="content">

			<div class="img-wrapper">
				<img src="/images/mobile-app-suggestion.png" height="80" width="auto" alt />
			</div>

			<h2>Works best with a desktop browser.</h2>

			<p>For seamless Databox experience we recommend using a desktop browser. </p>

			<div class="controls2 controls2--center">
				<SubmitButtonComponent
					@text="Open Databox mobile app"
					@size="big"
					@onTrigger={{this.openMobileApp}}
				/>
				<SubmitButtonComponent
					@text="Continue on mobile"
					@theme="grey-empty"
					@onTrigger={{this.close}}
				/>
			</div>
		</div>
	</template>
}
